import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CategoryComponentLibrary } from '../stores/libraries/CategoryComponentLibrary';
import { TextInputComponent } from './FormComponents/TextInputComponent';
import { useStores } from '../stores/Hooks';
import { StatementTypeEnum } from '../models';

interface ICategoryComponent
{
    /** Библиотека компнента */
    lib: CategoryComponentLibrary,

    /** Номер компонента по порядку */
    order: number

}

export const CategoryComponent: React.FC<any> = observer(
    (
        {
            lib,
            order
        }: ICategoryComponent
    ) =>
    {
        const store = lib;
        const { uiState } = useStores();

        return (
            <>
                <hr className="d-lg-none form-block-mobile-separator" />

                <div className={"form-block form-block-bordered" + (order === 0 ? " mb-4" : "") + (uiState.register.StatementType === StatementTypeEnum.RemoveInformation ? " d-none" : "")}>
                    <div className="form-block-header modal-header">{lib.Category.Name}</div>
                    <div className="row">
                        <div className="col-xl-6 mb-2 mb-md-3 mb-lg-4">
                            <TextInputComponent
                                IsRequired={true}
                                Error="Некорректный телефон"
                                IsDisabled={store.Phone.IsDisabled}
                                IsValid={store.Phone.IsValid}
                                Label="Телефон технической поддержки"
                                MaxLength={60}
                                Placeholder="Введите телефон"
                                Value={store.Phone.Value ?? ""}
                                OnChange={(value: string) => store.Phone.setValue(value)}
                                OnValidate={() => store.Phone.Validate()}
                                AutoComplete="tel"
                            />
                        </div>
                        <div className="col-xl-6 mb-2 mb-md-3 mb-lg-4">
                            <TextInputComponent
                                IsRequired={true}
                                Error="Некорректный адрес электронной почты"
                                IsDisabled={store.Email.IsDisabled}
                                IsValid={store.Email.IsValid}
                                Label="Адрес электронной почты"
                                MaxLength={320}
                                Placeholder="Введите адрес электронной почты"
                                Value={store.Email.Value ?? ""}
                                OnChange={(value: string) => store.Email.setValue(value)}
                                OnValidate={() => store.Email.Validate()}
                                AutoComplete="email"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6">
                            <TextInputComponent
                                IsRequired={true}
                                Error="Ссылка должна начинаться с http:// или https://"
                                IsDisabled={store.Web.IsDisabled}
                                IsValid={store.Web.IsValid}
                                Label="Ссылка на официальный сайт или услугу"
                                MaxLength={2000}
                                Placeholder="Введите адрес сайта"
                                Value={store.Web.Value ?? ""}
                                OnChange={(value: string) => store.Web.setValue(value)}
                                OnValidate={() => store.Web.Validate()}
                                AutoComplete="url"
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
)
